import { useMachines } from "../api/queries/useMachines"
import { MultiSelect } from "primereact/multiselect"

export default function MachineMultiFilter(props) {
  const { data: machines = [] } = useMachines()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={machines}
      placeholder={"Stroj"}
      optionLabel={"name"}
      optionValue={"uuid"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
